// Service Worker Registration Utility
export function registerServiceWorker() {
  // Only register service worker in production to avoid reload loops in development
  if (process.env.NODE_ENV !== 'production') {
    console.log('[Service Worker] Skipping registration in development mode');
    return;
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Get the public URL from environment or use current origin
      const publicUrl = process.env.PUBLIC_URL || '';
      const swUrl = publicUrl ? `${publicUrl}/sw.js` : '/sw.js';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[Service Worker] Registration successful:', registration.scope);

          // Only check for updates periodically, not immediately
          // Check for updates every hour
          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000);

          // Handle updates - only prompt when there's an actual update
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                // Only show update prompt if there's already a controlling service worker
                // This means it's an update, not the first install
                if (
                  newWorker.state === 'installed' &&
                  navigator.serviceWorker.controller &&
                  !registration.waiting
                ) {
                  // New service worker available
                  console.log('[Service Worker] New version available');
                  // Show notification but don't auto-reload
                  // User can manually reload or we can show a toast notification
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error('[Service Worker] Registration failed:', error);
        });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then((success) => {
          if (success) {
            console.log('[Service Worker] Unregistered:', registration.scope);
          }
        });
      });
    });
  }
}

